import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // Allow large uploads (multiple base64 images)
  maxContentLength: 60 * 1024 * 1024,
  maxBodyLength: 60 * 1024 * 1024,
});

/** Read a File object as a plain base64 string (no data URL prefix). */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      const result = reader.result || "";
      const comma = String(result).indexOf(",");
      resolve(comma >= 0 ? String(result).slice(comma + 1) : String(result));
    };
    reader.readAsDataURL(file);
  });
}

export async function generateQuestions({ chapterNote, files }) {
  const payload = {
    chapterNote: chapterNote || "",
    files: await Promise.all(
      files.map(async (f) => ({
        name: f.name,
        mediaType: f.type || "image/png",
        data: await fileToBase64(f),
      }))
    ),
  };
  const { data } = await api.post("/generate", payload);
  return data;
}

export async function listSets() {
  const { data } = await api.get("/sets");
  return data;
}

export async function saveSet(payload) {
  const { data } = await api.post("/sets", payload);
  return data;
}

export async function deleteSet(id) {
  const { data } = await api.delete(`/sets/${id}`);
  return data;
}

export async function downloadPdf({ name, chapterNote, questions }) {
  const response = await api.post(
    "/pdf",
    { name, chapterNote, questions },
    { responseType: "blob" }
  );
  const cd = response.headers["content-disposition"] || "";
  const match = /filename="?([^"]+)"?/.exec(cd);
  const filename = match ? match[1] : "hikari-study-set.pdf";
  return { blob: response.data, filename };
}

// --- Auth ----------------------------------------------------------------
export async function fetchMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function exchangeSession(sessionId) {
  const { data } = await api.post("/auth/session", { session_id: sessionId });
  return data.user;
}

export async function logout() {
  const { data } = await api.post("/auth/logout");
  return data;
}
